<template>
  <b-container fluid>
    <page-header title="Group Company List">
      <template #actions>
        <button-options
          :access="canRead('master_group_company')"
          :hideDetail="true"
          :isBackEnabled="true"
          :isRefreshEnabled="true"
          :refreshed="isLoading"
          @onRefreshed="getData('Refreshed')"/>
      </template>
    </page-header>
    <div class="iq-card">
      <div class="iq-card-body">
        <div class="row" v-if="isLoading">
          <div class="col-md-12">
            <div class="text-center text-danger my-2">
              <wave-loader size="lg">Loading...</wave-loader>
            </div>
          </div>
        </div>
        <div class="row" v-if="companies.length > 0 && !isLoading">
          <b-col cols="3" v-for="(data, index) in companies" v-bind:key="`D-${index}`">
            <b-card class="text-center btn card-item-group m-1"
                    :id="`groupCard${index}`"
                    @click="onItemClicked(data.compId)">
              <b-card-text>
                <i class="ri-building-line"></i>
                {{data.compName}}
              </b-card-text>
            </b-card>
          </b-col>
        </div>
        <div class="row" v-if="companies.length <= 0 && !isLoading">
          <b-col cols="12" class="text-center">
            No data to be displayed
          </b-col>
        </div>
      </div>
    </div>

  </b-container>
</template>

<script>

import ButtonOptions from '@/components/directives/button-options';
import CompanySvc from '@/services/CompanySvc';

import requestBuilder from '@/util/master/request.builder';
import { isCancelled, requestErrorMessage } from '@/util/master/requestError';

export default {
  name: 'GroupDetail',
  components: { ButtonOptions },
  data() {
    return {
      companies: [],
      filter: {
        compGrcpId: this.$route.params.id,
      },
      id: this.$route.params.id,
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
    };
  },
  methods: {
    async getData(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const resp = await CompanySvc.getCompanies({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.filter),
          },
        });
        if (notification) {
          this.$toast.success(notification);
        }
        this.companies = resp.data.data || [];
      } catch (e) {
        if (isCancelled(e)) return;
        this.$toast.error(requestErrorMessage(e));
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onItemClicked(id) {
      this.$router.push({ name: 'CompanyDetail', params: { id } });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>

</style>
